import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {PlaceholderChildComponent} from '@ispm/layout/classes/placeholder-child-component.abstract';
import {NodeCreationResult} from '@ispm-client/modules/bpmn-modeler/models/node-creation-result';
import {Condition, NodeType, QueryNode} from '@ispm-client/modules/query-builder/models/query-builder-config';
import {DynamicModalLoaderService} from '@ispm/layout/services/dynamic-modal-loader.service';
import {cloneDeep, get} from "lodash";
import {NodePanelConfigurationService} from "@ispm-client/modules/bpmn-modeler/service/node-panel-configuration.service";
import {FormHandlerService} from "@ispm/dynamic-form/services/form-handler.service";
import {GuidedBoxPayload} from "@ispm/shared/classes/guided-box-payload.class";
import {ModalManagementService} from "@ispm/layout/services/modal-management.service";

@Component({
  selector: 'ispm-node-creator',
  templateUrl: './node-creator.component.html',
  styleUrls: ['./node-creator.component.scss']
})
export class NodeCreatorComponent extends PlaceholderChildComponent<any> implements OnInit {

  nodeInfoValid: boolean;
  queryBuilderValid: boolean;
  guideBoxVisible = false;
  data: NodeCreationResult;
  defaultQueryNode: QueryNode = {
    negate: false,
    condition: Condition.AND,
    type: NodeType.HEAD,
    rules: [{
      condition: Condition.AND,
      type: NodeType.PARAMETER,
      rules: []
    }]
  };

  constructor(private nodePanelConfigurationService: NodePanelConfigurationService,
              private modalLoader: DynamicModalLoaderService,
              private formHandler: FormHandlerService,
              private changeDetRef: ChangeDetectorRef,
              private modalManagementService: ModalManagementService) {
    super();
  }

  beforeClose() {

  }

  ngOnInit() {
    this.data = cloneDeep(this.payload.data);
    if (!this.data.ruleset) {
      this.data.ruleset = cloneDeep(this.defaultQueryNode);
    }
    if (!this.data.guideBox) {
      this.data.guideBox = {};
    }

    this.nodePanelConfigurationService.storeNodeConfigurationData(cloneDeep(this.data), this.payload.readOnlyMode, true)
  }

  nodeInfoChanged(data, form) {
    this.data.name = form.name;
    if (!this.data.name) {
      delete this.data.name;
    }
    this.nodePanelConfigurationService.storeNodeConfigurationData(this.data, this.payload.readOnlyMode);
  }

  guidingTextChanged(evt) {
    this.data.guideBox.guidingText = evt;
    this.nodePanelConfigurationService.storeNodeConfigurationData(this.data, this.payload.readOnlyMode);
  }

  guideNoteModalConfirmed() {

  }

  openGuidePopup() {
    const attachmentConfig = get(this.payload.config, 'attachmentConfig', undefined);
    const editMode = {'editMode': !this.payload.readOnlyMode};
    const modalManagement = {'enableModalManagement': true};
    const modalEditMode = editMode.editMode;
    const curationGlobalConfiguration = Object.assign({}, attachmentConfig, editMode, modalManagement);
    this.formHandler.popupDynamicFormModal(
      'Guidance Note',
      'GUIDANCE_NOTES-CURATOR',
      {
        notes: {
          text: new GuidedBoxPayload(this.data.guideBox).getGuideTextWithLinks(),
          attachments: this.data.guideBox.attachments ? this.data.guideBox.attachments : [],
        },
        showAutomatically: this.data.guideBox.automatically
      },
      'Save',
      'Cancel',
      {globalConfigurations: curationGlobalConfiguration}, undefined, undefined, undefined, undefined, undefined, true, modalEditMode)
      .filter(response => (response as any).payload)
      .map(response => (response as any).payload)
      .subscribe(({formData}) => {
        this.modalManagementService.resetData();
        this.data.guideBox = {
          guidingText: formData.notes.text,
          attachments: formData.notes.attachments,
          automatically: formData.showAutomatically,
        };
        this.nodePanelConfigurationService.storeNodeConfigurationData(this.data, this.payload.readOnlyMode);
      });
  }

  updateQueryBuilder(valid: boolean | undefined) {
    this.nodePanelConfigurationService.storeNodeConfigurationData(cloneDeep(this.data), this.payload.readOnlyMode);

    // This method is also used to check if the query builder data changes,
    // so do not change queryBuilderValid value if valid === undefined: f.e. negation changed; see query-builder.component.ts
    if (valid !== undefined) {
      this.queryBuilderValid = valid;
    }
  }

  updateNodeInfo(valid) {
    this.nodeInfoValid = valid;
  }

  isNameEditable(): boolean {
    return get(this.payload.config.nodeBuilder, 'isNameEditable', true);
  }
}

